import './App.css';
import { Routes, Route, useLocation } from "react-router-dom";
import React, { useState, useRef } from "react";



import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import Navbar from './components/Navbar';
import Landing from './components/Landing';
import Categories from './components/Categories';
import Products from './components/Products';
import FamousCategories from './components/FamousCategories';
import Ad from './components/Ad';
import Footer from './components/Footer';
import CategoriesPage from './components/CategoriesPage';
import SubCategory from './components/SubCategory';
import Item from './components/Item';
import Cart from './components/Cart';





// Admin Pages


import SideNav from "./components/Admin/SideNav";
import LoginAdmin from "./components/Admin/LoginAdmin";


import SearchBar from "./components/Admin/SearchBar";
import Dashboard from "./components/Admin/Dashboard";
import AllUsersPage from "./components/Admin/AllUsersPage";
import EditUser from "./components/Admin/EditUser";
import AddUser from "./components/Admin/AddUser";


import AddCategory from './components/Admin/AddCategory';
import AllCategories from './components/Admin/AllCategories';
import EditCategory from './components/Admin/EditCategory';

import AddSubCategory from './components/Admin/AddSubCategory';
import AllSubCategories from './components/Admin/AllSubCategories';
import EditSubCategory from './components/Admin/EditSubCategory';






import EditSocial from './components/Admin/EditSocial';
import AllSocialPage from './components/Admin/AllSocialPage';



import AllOrders from './components/Admin/AllOrders';
import ViewOrders from './components/Admin/ViewOrders';

import AddProduct from './components/Admin/AddProduct';
import AllProducts from './components/Admin/AllProducts';
import EditProduct from './components/Admin/EditProduct';




function App() {






    
    const [sessionExists, setSessionExists] = useState("");
    const servicesRef = useRef(0);
    const location = useLocation();
    const hideHeaderFooter =
    location.pathname === "/dashboard" ||
    location.pathname === "/all-users" ||
    location.pathname === "/all-waiting-users" ||
    location.pathname === "/edit-user" ||
    location.pathname === "/add-user"||
    location.pathname === "/all-categories"||
    location.pathname === "/add-category"||
    location.pathname === "/edit-category"||
    location.pathname === "/all-sub-categories"||
    location.pathname === "/add-sub-category"||
    location.pathname === "/edit-sub-category"||
    location.pathname === "/all-sub-services"||
    location.pathname === "/add-sub-service"||
    location.pathname === "/edit-sub-service"|| 
    location.pathname === "/all-social"||
    location.pathname === "/all-orders"||
    location.pathname === "/all-orders"||
    location.pathname === "/view-orders"||
    location.pathname === "/view-orders"||
    location.pathname === "/all-products"||
    location.pathname === "/edit-product"||
    location.pathname === "/add-product"||
    location.pathname === "/edit-social";


return (
    <div className="App">

        <SideNav
        className={hideHeaderFooter ? "" : "hide"}
        sessionExists={sessionExists}
        setSessionExists={setSessionExists}
        />
        <SearchBar 
            className={hideHeaderFooter ? "" : "hide"}
        />

                                <Navbar className={!hideHeaderFooter ? "" : "hide"}/>

            <Routes>
            

            <Route path="/" element={
                    <>
                        <Landing />
                        <Categories />
                        <Products />
                        <FamousCategories />
                        <Products />
                        <Products />
                        <Ad />
                        <Products />


                    </>
                } />

                <Route path="/category" element={
                    <>
                        <CategoriesPage />
                        </>

                } />

                <Route path="/sub-category" element={
                    <>
                        <SubCategory />
                        </>

                } />

                <Route path="/item" element={
                    <>
                        <Item />
                        </>

                } />

                
            <Route path="/cart" element={
                    <>
                        <Cart />
                        </>

                } />




            <Route path="/admin-login"element={<><LoginAdmin sessionExists={sessionExists} setSessionExists={setSessionExists} /></>}/>
            <Route path="/dashboard"element={ <><Dashboard /> </>}/>
            <Route path="/all-users" element={ <><AllUsersPage /> </>}/>
            <Route path="/edit-user" element={<><EditUser /></>} />
            <Route path="/add-user" element={<><AddUser /></>}/>
            <Route path="/all-users"element={<><AllUsersPage /></> }/>
        
            <Route path="/all-categories"element={<><AllCategories /></> }/>
            <Route path="/add-category"element={<><AddCategory /></> }/>
            <Route path="/edit-category"element={<><EditCategory /></> }/>

            <Route path="/all-sub-categories"element={<><AllSubCategories /></> }/>
            <Route path="/add-sub-category"element={<><AddSubCategory /></> }/>
            <Route path="/edit-sub-category"element={<><EditSubCategory /></> }/>




            <Route path="/all-social" element={<><AllSocialPage /></> }/>
            <Route path="/edit-social" element={<><EditSocial /></> }/>


            <Route path="/all-orders" element={<><AllOrders /></> }/>
            <Route path="/view-orders" element={<><ViewOrders /></> }/>


            
            <Route path="/add-product"element={<><AddProduct /></> }/>
            <Route path="/all-products"element={<><AllProducts /></> }/>
            <Route path="/edit-product"element={<><EditProduct /></> }/>


            </Routes>

        <Footer className={!hideHeaderFooter ? "" : "hide"}/>



        
    </div>
);
}

export default App;
